import {AfterViewChecked, Directive, ElementRef, OnInit,} from '@angular/core';
import {NgControl,} from '@angular/forms';

@Directive({
  selector: '[formControlName]',
})
export class NativeElementInjectorDirective implements OnInit, AfterViewChecked {

  constructor(
    private el: ElementRef<HTMLElement>,
    private control : NgControl
    ) {}

  ngOnInit(): void {
    // 該当画面項目をコントロールに格納
    if (this.control && this.control.control) {
      this.control.control['nativeElement'] = this.el.nativeElement;
    }
  }

  ngAfterViewChecked(): void {

    // コントロールがない場合、メソッドから出る
    if (!this.control || !this.control.control) {
      return;
    }

    const tab = this.el.nativeElement.parentElement?.closest('[id*="tab-content"]');
    const parentTab = tab?.parentElement?.closest('[id*="tab-content"]');
    if (tab) {
      // タブで囲まれている場合、項目の配置を取得し格納
      const bounds = this.el.nativeElement.getBoundingClientRect();
      if (Math.max(bounds.top, bounds.left) > 0) {
        this.control.control['bounds'] = bounds;
      }

      // 項目が含まれるTab GroupのページとそのTab Groupが含まれる親Tab Groupの
      // ページを判断し、ページのIDを取得して格納
      if (parentTab) {
        this.control.control['tabFirstElementId'] = parentTab.id;
        this.control.control['tabSecondElementId'] = tab.id;
      } else if (!this.control.control['tabFirstElementId']
        && Math.max(bounds.top, bounds.left) > 0) {
          this.control.control['tabFirstElementId'] = tab.id;
      } else if (!this.control.control['tabSecondElementId']
        && Math.max(bounds.top, bounds.left) <= 0) {
          this.control.control['tabSecondElementId'] = tab.id;
      }
    }

    // 項目が含まれるStepperのページを判断し、ページのID取得して格納
    const step = this.el.nativeElement.parentElement?.closest('[id*="step-content"]');
    if (step && !this.control.control['stepElementId']) {
      this.control.control['stepElementId'] = step.id;
    }

    // 項目が含まれるAccordionのパネルを判断し、パネルのID取得して格納
    const accordion = this.el.nativeElement.parentElement?.closest('[id*="accordion-child"]');
    if (accordion && !this.control.control['accordionElementId']) {
      this.control.control['accordionElementId'] = accordion.id;
    }

    // 項目が含まれるタブ形のdivを判断
    const parentTabBox = this.el.nativeElement.parentElement?.closest('.tab-box');
    if (!parentTabBox) {
      return;
    }

    // タブ形のdivがある場合、項目の位置と該当タブの採番を格納
    const bounds = this.el.nativeElement.getBoundingClientRect();
    if (!this.control.control['bounds'] && Math.max(bounds.top, bounds.left) > 0) {
      this.control.control['bounds'] = bounds;
    }
    if (this.control.control['contentDivIndex'] == null) {
      const contentDivs = Array.from(parentTabBox?.querySelectorAll('.content_class'));
      const contentDiv = this.el.nativeElement.parentElement?.closest('.content_class');
      if (contentDivs.length > 0 && contentDiv) {
        this.control.control['contentDivIndex'] = contentDivs.indexOf(contentDiv);
      }
    }
  }
}

